import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {MessageModel} from '../../../api/model/messageModel';
import {AbstractRepositoryV2} from '../../../../core/service/v2/abstractRepositoryV2';

@Injectable()
export class MessageRepository extends AbstractRepositoryV2<MessageModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Message', serviceElementsFactory, injector);
    }
}
